module.exports = __webpack_public_path__ + "img/spain-ischemic-heart-disease-male.1df7ec84.png";